import Api from './index';

export default function plugin(Vue) {
  if (plugin.installed) {
    return;
  }
  plugin.installed = true;

  Object.defineProperty(Vue.prototype, '$api', {
    get() {
      return Api;
    },
  });
}
